import { h, SetupContext, VNode } from 'vue';

interface LabelProps {
  label: string;
}

/**
 * For input like checkbox, radiobutton, toggleswitch, etc.
 *
 * Conditionally wrap the input with label element when props.label is defined.
 *
 * @param propsData
 * @param setupContext
 * @returns
 */
const Label = (propsData: LabelProps, setupContext?: SetupContext): VNode => {
  const { attrs, slots } = setupContext || {};
  return (
    propsData.label ? h('label', attrs, slots.default()) : slots.default()
  ) as VNode;
};

export default Label;
